import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ParcelItemsAiLoadingOverlayContainer } from './styles';

export enum ParcelItemsAiLoadingMode {
  Image = 'Image',
  Audio = 'Audio',
}

interface ParcelItemsAiLoadingOverlayProps {
  mode: ParcelItemsAiLoadingMode;
}

const ParcelItemsAiLoadingOverlay = ({
  mode,
}: ParcelItemsAiLoadingOverlayProps) => {
  const { t } = useTranslation();
  const isImageMode = mode === ParcelItemsAiLoadingMode.Image;

  return ReactDOM.createPortal(
    <ParcelItemsAiLoadingOverlayContainer
      aria-live='polite'
      aria-busy='true'>
      <div className='ai-loading-content'>
        <span
          className='ai-loading-spinner'
          aria-hidden='true'
        />
        <div className='ai-loading-copy'>
          <h2>
            {t(
              isImageMode
                ? 'parcel_items_ai_loading_image_title'
                : 'parcel_items_ai_loading_audio_title'
            )}
          </h2>
          <p>
            {t(
              isImageMode
                ? 'parcel_items_ai_loading_image_description'
                : 'parcel_items_ai_loading_audio_description'
            )}
          </p>
        </div>
      </div>
    </ParcelItemsAiLoadingOverlayContainer>,
    document.body
  );
};

export default ParcelItemsAiLoadingOverlay;
